import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../../stores/RootStore';
import { StudentAttendanceList, StudentAttendanceParam, StudentAttendanceCallStatusUpdate } from '../../models/Attendance';
import { ISelect } from '../../models/General';
import Select from "react-select";
import MaterialTable from "material-table";
import { TableIcons } from '../../utils/Icons';
import Alert from '@mui/material/Alert/Alert';
import { CircleSpinnerOverlay  } from 'react-spinner-overlay'
import Modal from 'react-bootstrap/Modal';
import CallFeedbackForm from '../../utils/CallFeedbackForm';
import StudentAttendanceListDetail from './StudentAttendanceListDetail';

const StudentAttendanceListPage = () => {
    
    const rootStore = useContext(RootStoreContext);
    const { getStudentAttendanceList,getCreatedDate, processUpdateCallStatus, getCallReason } = rootStore.attendanceStore;
    const { getInstitution, getSemester} = rootStore.commonStore; 
    const emplidVal =  window.localStorage.getItem('emplid'); 

    const callStatusData = [
        {label:'Not Called',value:'0'},
        {label:'Called',value:'1'},
    ]

    const [list, setList] = useState<StudentAttendanceList[]>([]) 

    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career] = useState<string>("UGRD");
    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [createdDttm, setCreatedDttm] = useState<ISelect[]>();
    const [createdDttmVal, setCreatedDttmVal] = useState<string>('');
    const [callStatus, setCallStatus] = useState<ISelect[]>(callStatusData); // untuk selectnya 
    const [callStatusVal, setCallStatusVal] = useState<string>('0'); // untuk value yang dikirim ke backend
    const [callStatusShownVal, setCallStatusShownVal] = useState([{label:'Not Called',value:'0'}]); // untuk value yang ditampilkan di user

    const [btnUpdate, setBtnUpdate] = useState(true) 
    const [btnUpdateLabel, setBtnUpdateLabel] = useState('') 

    const [status, setStatus] =  useState("success") 
    const [message, setMessage] = useState("") 
    const [statusAlert, setStatusAlert] = useState(0) 
    const [btnExport, setBtnExport] = useState(true) 

    const [isLoading, setIsLoading] = useState(false)
    
    const [modalData, setModalData] = useState()
    const [IsModalOpen, setIsModalOpen] = useState(false);
    

    function exportExcel() 
    {
        setIsLoading(true);
        const token = window.localStorage.getItem('token');
        // let file = `${process.env.REACT_APP_API_URL}/academic/attendance/export-student2/${institutionVal}/${semesterVal}/${createdDttmVal}/${callStatusVal}/${emplidVal}`;
        let file = `${process.env.REACT_APP_API_URL}/academic/attendance/export-student/${institutionVal}/${semesterVal}/${createdDttmVal}/${callStatusVal}`;
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        fetch(file, { 
            headers,
            method: 'get'
            
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            setIsLoading(false)
            anchor.href = objectUrl;
            anchor.download = 'Student_Attendance_Recap.xls';
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        });
    };


    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);

        const semesterData = getSemester(event.value, career);
        semesterData.then(function(result) {
            setSemester(result)
        })

    };

    function handleSemesterSelect (event: any) {
        setSemesterVal(event.value)
        const createdDateData = getCreatedDate(String(institutionVal),event.value)
        createdDateData.then((result) => {
            setCreatedDttm(result)
        })

        
    };

    function handleCreatedDateSelect(event: any){
        setCreatedDttmVal(event.value)
        setIsLoading(true);
        if(event.value!==""){
            setBtnExport(false)
        }
    }

    function handleCallStatusSelect(event: any){
        setCallStatusVal(event.value)
        setCallStatus(callStatusData)
        setCallStatusShownVal(event)
    }

    function handleUpdateForm(rowData:any,updateParam:any){
        
        setIsLoading(true);
        const data: StudentAttendanceCallStatusUpdate[] = [rowData];
        const newParam = new Array();
        // console.log(data)
        // console.log(list)
        var new_call_status = 1

        //jika call status filter adalah called, update menjadi not called
        if(callStatusVal !== '0'){
            new_call_status = 0
        }
        
        var param = {
            INSTITUTION: rowData.INSTITUTION,
            ACAD_CAREER: rowData.ACAD_CAREER,
            EMPLID: rowData.EMPLID,
            STRM: rowData.STRM,
            CREATED_BATCH: rowData.CREATED_BATCH,
            CALL_STATUS: new_call_status,
            CALL_BY:updateParam.callerName,
            REASON_ID:updateParam.callReasonId,
            REMARKS:updateParam.remarks,
            OPT_EMPLID: emplidVal
        }
        newParam.push(param)

        processUpdateCallStatus(newParam).then(function(response) {
            setStatusAlert(1)
            setMessage(response.message)
            setStatus(response.variant)
            setList(list.filter(x => !data.includes(x)))
            setIsLoading(false)
            closeModal()
        })
    }

    function handleOpenModal(rowData:any){
        setIsModalOpen(true)
        setModalData(rowData)
    }
    
    function closeModal() {
        setIsModalOpen(false);
    }

    function handleUpdateToNotCalled(rowData:any){
        handleUpdateForm(rowData,{})
    }

    const param: StudentAttendanceParam = {
        INSTITUTION: String(institutionVal),
        STRM: String(semesterVal),
        CREATED_DTTM: String(createdDttmVal),
        CALL_STATUS: String(callStatusVal)
    };

    function loadData()
    {
        if(callStatusVal == '0'){
            setBtnUpdate(true)
            setBtnUpdateLabel('')
        }
        else{
            setBtnUpdate(false)
            setBtnUpdateLabel('to Not Called')
        }
        
        getStudentAttendanceList(param).then(function(response) {
            setList(response)
            setIsLoading(false)
        })  
        .catch(() => {
            setStatusAlert(1)
            setMessage("Unable to fetch data")
            setStatus("danger")
            setIsLoading(false);
        });
    }

    useEffect(() => {

        if(institutionVal !== '' && semesterVal !== '' && createdDttmVal !== '' ){
            setIsLoading(true);
        }

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function(result) {
            setInstitution(result);
        })

        loadData()

    },[institutionVal, semesterVal,createdDttmVal,callStatusVal])

    return (
        <React.Fragment>
            {isLoading
            ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading}　color="#00FFFF" />
            : <></>
            }
            
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Student absence</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <Modal show={IsModalOpen} onHide={closeModal}>
                    <Modal.Header closeButton>
                    <Modal.Title>Call Feedback</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CallFeedbackForm rowData={modalData} handleUpdateForm={handleUpdateForm} getCallReason={getCallReason} ></CallFeedbackForm>
                    </Modal.Body>  
                </Modal>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Created Batch</label>
                                                <Select
                                                    name="created-dttm"
                                                    placeholder="Choose Created Batch"
                                                    options={createdDttm}
                                                    onChange={handleCreatedDateSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <Select
                                                    name="call-status"
                                                    placeholder="Choose Status"
                                                    options={callStatus}
                                                    value={callStatusShownVal}
                                                    onChange={handleCallStatusSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <div className="form-group">
                                                <label> &nbsp;</label>
                                                <button hidden={btnExport}  onClick={() => exportExcel()} className="btn btn-info" type="button">Export</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {
                                statusAlert == 1 ? 
                                <>
                                <Alert variant="filled" severity={'success' || status} onClose={() => { setStatusAlert(0) }}>{message}</Alert>
                                </> : <> </> 
                            }
                            <br></br>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Students List</h3>
                                </div>
                                <div className="card-body">

                                    <MaterialTable
                                        title=""
                                        icons={TableIcons}
                                        columns={[
                                            {
                                                title: "Update",
                                                render: (rowData:any) => (
                                                    <div className="btn btn-primary" 
                                                    onClick={() =>{ 
                                                        if(btnUpdate){
                                                            handleOpenModal(rowData)
                                                        }
                                                        else{
                                                            handleUpdateToNotCalled(rowData)
                                                        }
                                                        
                                                    }}>Update {btnUpdateLabel}</div>
                                                )
                                            },
                                            {title: "ID", field: "EMPLID",defaultSort:"asc"},
                                            {title: "Name", field: "NAME_DISPLAY",},
                                            {title: "Class Of", field: "ACAD_YEAR"},
                                            {title: "Program", field: "ACAD_PROG_BHS"},
                                            {title: "Email", field: "EMAIL_ADDR"},
                                            {title: "Phone", field: "PHONE1"},
                                            // {title: "Father's Phone", field: "NO_HP_AYAH"},
                                            // {title: "Mother's Phone", field: "NO_HP_IBU"},
                                            {title: "Parents's Phone", field: "NO_HP_ORANGTUA"},
                                            // {title: "Course Name", field: "MATAKULIAH",defaultSort:"asc"},
                                            // {title: "Class", field: "CLASS_SECTION",defaultSort:"asc"},
                                            // {title: "Number of Absences", field: "JUMLAH_ABSEN"},
                                            // {title: "Max Absences", field: "MAKS_ABSEN"},
                                            // {title: "Number of Absences", field: "JUMLAH_ABSEN_DESC"},
                                            {title: "Call Time", field: "CALL_DTTM"},
                                            {title: "Call By", field: "CALL_BY"},
                                            {title: "Reason", field: "REASON_DESC"},
                                            {title: "Remarks", field: "REMARKS"},

                                        ]}
                                        data={list}
                                        options={{
                                            sorting:true,
                                            filtering: true,
                                            selection: false,
                                            showSelectAllCheckbox:false,
                                            emptyRowsWhenPaging: false,
                                            pageSize: 25,
                                            pageSizeOptions: [5, 10, 25, 50],
                                            loadingType: 'overlay',
                                            headerStyle: {
                                                fontWeight: 'bold',
                                            },
                                            rowStyle: rowData => ({
                                                backgroundColor: "#FFF",
                                                // backgroundColor: rowData.tableData.id % 2 === 0 ? "#EEE" : "#FFF",
                                            }),

                                        }}
                                        detailPanel={rowData => {
                                            return (
                                                <StudentAttendanceListDetail rowData={rowData} ></StudentAttendanceListDetail>
                                            )
                                        }}
                                        // actions={[
                                        //     {
                                        //         tooltip: 'Approve',
                                        //         icon: () => { return ( <button disabled={btnApprove} hidden={hiddenBtnApprove} className="btn btn-info"> Update Status to '{btnApproveLabel}' </button> ) },
                                        //         onClick: (event, rowData) => {
                                        //             updateCallStatus(rowData)
                                        //         },
                                        //         isFreeAction: false
                                        //     }
                                        // ]}
                                        
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            
        </React.Fragment>
    );
}

export default StudentAttendanceListPage;